import { useMemo } from 'react';
import { addMediaAccountConnectClick, addMediaAccountDisconnectClick } from '@wix/bi-logger-media-data/v2';
import { bi } from '../../../services/loggers/bi';

export const useTrackAddMediaAccountAnalytics = () =>
  useMemo(
    () => ({
      trackAddMediaAccountConnectConnected: (externalSource) => {
        bi.logger().report(
          addMediaAccountConnectClick({
            target: externalSource,
          }),
        );
      },
      trackAddMediaAccountConnectDisconnected: (externalSource) => {
        bi.logger().report(
          addMediaAccountDisconnectClick({
            target: externalSource,
          }),
        );
      },
    }),
    [],
  );
